<template>
  <v-container class="pa-10">
    <div class="text-h5">Meu cadastro</div>
    <v-divider />
    <v-row class="py-10 pl-7">
      <v-badge avatar bordered overlap>
        <template v-slot:badge>
          <v-avatar>
            <v-icon dark> mdi-camera </v-icon>
          </v-avatar>
        </template>
        <v-file-input
          id="foto-perfil"
          ref="image"
          :v-model="foto"
          v-show="false"
          @change="submitImage"
          accept="image/png, image/jpeg, image/jpg image/bmp"
        ></v-file-input>
        <v-btn fab x-large @click="changeImage()">
          <v-avatar size="100" class="grey lighten-2">
            <img :src="avatar" />
          </v-avatar>
        </v-btn>
      </v-badge>
    </v-row>
    <v-form ref="form" @submit="handleSubmit">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            outlined
            v-model="userData.nome"
            label="Nome"
            hide-details
            :rules="required"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            outlined
            v-model="userData.celular"
            label="Celular"
            v-mask="['(##) #####-####']"
            hide-details
            :rules="required"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            outlined
            v-model="userData.email"
            label="Email"
            hide-details
            :rules="required"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>

    <div class="text-h6">Alterar senha</div>
    <v-divider />

    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          outlined
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          name="input-10-2"
          label="Senha atual"
          class="input-group--focused"
          @click:append="show = !show"
          v-model="userData.senha"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          outlined
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          cols="12"
          md="3"
          name="input-10-2"
          label="Nova senha"
          class="input-group--focused"
          @click:append="show = !show"
          v-model="userData.novaSenha"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          outlined
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          cols="12"
          md="3"
          name="input-10-2"
          label="Repetir nova senha"
          class="input-group--focused"
          @click:append="show = !show"
          v-model="userData.novaSenhaRepetir"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="text-end">
      <v-col cols="7" md="9">
        <v-btn color="indigo darken-3" dark @click="handleSubmit"
          >Salvar Alterações</v-btn
        >
      </v-col>
    </v-row>
    <v-snackbar
      right
      top
      color="success"
      v-model="snackbar"
      :timeout="6000"
    >
      Cadastro alterado com sucesso.
      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          <v-icon dark> mdi-colse </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      avatar: '',
      foto: '',
      snackbar: false,
      show: false,
      required: [(v) => !!v || 'Este campo é obrigatório'],
      userData: {
        nome: '',
        celular: '',
        email: '',
        idUsuario: '',
        senha: '',
        novaSenha: '',
        novaSenhaRepetir: '',
      },
    }),

    computed: {
      ...mapState('auth', ['currentUser']),
      isChangingPassword() {
        return (
          this.userData.senha &&
          this.userData.novaSenha &&
          this.userData.novaSenhaRepetir
        );
      },
    },

    mounted(){
      if(localStorage.getItem('auth.currentUser')){
        this.userData = JSON.parse(localStorage.getItem('auth.currentUser'));
      }
    },

    methods: {
      ...mapActions('user', ['changeUserData', 'changeUserPassword']),
      ...mapActions('auth', ['getCurrentUser']),
      setUserData() {
        Object.keys(this.userData).forEach(
          (key) => (this.userData[key] = this.currentUser[key]),
        );
      },

      async handleSubmit() {
        if (this.isChangingPassword) {
          const passwords = {
            senha: this.userData.senha,
            novaSenha: this.userData.novaSenha,
            novaSenhaRepetir: this.userData.novaSenhaRepetir,
            idUsuario: this.userData.idUsuario,
          }
          await this.changeUserPassword(passwords);
        }
        
        const resp = await this.changeUserData(this.userData);
        if(resp === 200){
          this.getCurrentUser(this.userData.idUsuario)
          this.snackbar = true;
        }

      },

      changeImage() {
        document.getElementById('foto-perfil').click();
      },

      submitImage(e) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.avatar = e.target.result;
        };
        reader.readAsDataURL(e);
      },
    },
  };
</script>